import UserResourcePagingResultModel from '../../generated/types/model/resource/UserResourcePagingResultModel';

export default class UserResourcePagingResultViewModel extends UserResourcePagingResultModel {
  protected transformToDTO() {}
  protected transformFromDTO() {}
}
